export default "__VITE_ASSET__PZCKLKZp__"